import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import { EventDetailView } from './EventDetailView'
import { EventEditView } from './EventEditView'
import { EventsListView } from './EventsListView'

export const EventsView: React.FC = () => {
  return (
    <Routes>
      <Route path="" element={<EventsListView />} />
      <Route path="show/:id" element={<EventDetailView />} />
      <Route path="edit/:id" element={<EventEditView />} />
      <Route path="*" element={<Navigate to="/admin/events" replace />} />
    </Routes>
  )
}
